import { Link } from '@tanstack/react-router';
import { Button } from 'shared-ui';

export function NotFoundView() {
    return (
        <main className="flex min-h-full flex-col items-center justify-center px-6 text-center">
            <section className="w-full max-w-[360px]">
                <h1 className="text-muted-foreground text-[96px] leading-none font-extrabold tracking-tight">404</h1>

                <p className="text-foreground mt-4 text-sm font-semibold">
                    We couldn&apos;t find what you&apos;re looking for
                </p>

                <p className="text-muted-foreground mt-2 text-xs">It might have been moved or no longer exists.</p>

                <div className="mt-6 flex flex-col gap-3">
                    <Button render={<Link to="/find-and-fix" />} className="h-10 w-full">
                        Return To Origin Orbit®
                    </Button>

                    <Button render={<Link to="/find-and-fix" />} variant="outline" className="h-10 w-full">
                        Report Issue
                    </Button>
                </div>
            </section>
        </main>
    );
}
